<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import StartButton from '@/components/button/StartButton.vue';

const isScrolled = ref(false);

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50;
};

onMounted(() => window.addEventListener('scroll', handleScroll));
onUnmounted(() => window.removeEventListener('scroll', handleScroll));
</script>

<template>
  <nav :class="['navbar', { 'navbar-scrolled': isScrolled }]">
    <div class="nav-container">
      <router-link to="/" class="logo-link">
        <img src="@/assets/logo-brand.svg" alt="betPic" class="brand-logo" />
      </router-link>
      
      <div class="nav-links">
        <router-link to="/" class="nav-link">Home</router-link>
        <router-link to="/features" class="nav-link">Features</router-link>
        <StartButton iconOnly />
      </div>
    </div>
  </nav>
</template>

<style scoped>
.navbar {
  position: fixed;
  top: 20px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 1000;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar-scrolled {
  top: 10px;
}

.nav-container {
  width: 90%;
  max-width: 1200px;
  height: 64px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  background: var(--bg-navbar);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.brand-logo {
  height: 40px;
  width: auto;
  display: block;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 32px;
  margin-left: auto;
}

.nav-link {
  text-decoration: none;
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.95rem;
  transition: color 0.3s ease;
  position: relative;
}

.nav-link:hover, .nav-link.router-link-exact-active {
  color: var(--text-primary);
}

.nav-link.router-link-exact-active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--grad-main);
  border-radius: 2px;
}


@media (max-width: 768px) {
  .navbar, .navbar-scrolled {
    top: 0;
  }

  .nav-container {
    width: 100%;
    border-radius: 0;
    padding: 0 16px;
    height: 56px;
    border-top: none;
    border-left: none;
    border-right: none;
  }

  .brand-logo {
    height: 28px;
  }

  .nav-links {
    gap: 16px;
  }

  .nav-link {
    font-size: 0.85rem;
  }
}
</style>
